import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private api: ApiService) { }

    getAllCategory(data:any): Observable<any> {
        return this.api.post(environment.getAllCategory,data);
    }

    deleteCategory(data:any): Observable<any> {
        return this.api.post(environment.deleteCategory,data);
    }

    createCategory(data:any): Observable<any> {
        return this.api.post(environment.createCategory,data);
    }

    updateCategory(data:any): Observable<any> {
        return this.api.post(environment.updateCategory,data);
    }

}

  

